import Loader from 'components/animatedLoader';
import IntlMessages from 'components/utility/IntlMessages';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import actions from 'redux/auth/actions';
import ValidateStyled from './validate.style';

class Validate extends React.Component {
  static propTypes = {
    location: PropTypes.object,
    validate: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    history: PropTypes.object,
  };

  componentDidMount() {
    const {
      location: { search },
      validate,
    } = this.props;
    const searchParams = new URLSearchParams(search);
    const code = searchParams.get('code');
    // The post-login dashboard redirect is decided at OAuth-initiation time (see RestrictedRoute in
    // router.jsx), based on the real page-load entry. Code exchange here must not re-derive it: a
    // silent token re-validation also lands on this route and must NOT bounce the user to dashboard.
    validate(code);
  }

  render() {
    return (
      <ValidateStyled>
        <Loader type="cube-transition" scale="2" />
        <div className="title">
          <IntlMessages id="login.loading" />
        </div>
      </ValidateStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoggedIn: state.Auth.get('loggedIn'),
});

const mapDispatchToProps = {
  validate: actions.validate,
};

export default connect(mapStateToProps, mapDispatchToProps)(Validate);
